import { Action } from '@ngrx/store';
import { MeteringPoint } from '../../../models/metering-point.model';
import { MeteringPointDisruptions } from 'app/models/disruptionInfo.model';
import { ClimateCompensatedCO2Data, MeteringPointFunctionControl, MeteringPointReadingPoint, MeteringPointSettings } from '@model';
import { DatePeriodType, MeteringType } from '@enums';
import { MeteringPointTabType } from 'app/models/enums/metering-point-tab-type.enum';


export enum MeteringPointActionTypes {
  LoadMeteringPointData = '[MeteringPoint] Load',
  LoadMeteringPointDataSuccess = '[MeteringPoint] Load success',
  LoadMeteringPointDataFail = '[MeteringPoint] Load fail',
  LoadMeteringPointsDisruptionsData = '[MeteringPointsDisruptions] Load',
  LoadMeteringPointsDisruptionsDataSuccess = '[MeteringPointsDisruptions] Load success',
  LoadMeteringPointsDisruptionsDataFail = '[MeteringPointsDisruptions] Load fail',
  CreateReportKey = '[MeteringPoint] Create report key',
  CreateReportKeySuccess = '[MeteringPoint] Create report key success',
  CreateReportKeyFail = '[MeteringPoint] Create report key fail',
  LoadMeteringPointFunctionControls = '[MeteringPoint] Load funtion controls',
  LoadMeteringPointFunctionControlsSuccess = '[MeteringPoint] Load funtion controls success',
  LoadMeteringPointFunctionControlsFail = '[MeteringPoint] Load funtion controls error',
  ClearMeteringPoints = '[MeteringPoint] Clear MeteringPoints',
  SelectMeteringPoint = '[MeteringPoint] Select MeteringPoint',
  SelectMeteringPointById = '[MeteringPoint] Select MeteringPoint by Id',
  UnselectMeteringPoint = '[MeteringPoint] Unselect MeteringPoint',
  SelectTabIndexMeteringPoint = '[MeteringPoint] Select Tabindex for MeteringPoint',
  SelectTabIndexMeteringPoints = '[MeteringPoint] Select Tabindex for MeteringPoints',
  SelectPageIndexHotMeteringPoint = '[MeteringPoint] Select Page index for Hot MeteringPoints',
  SelectPageIndexColdMeteringPoint = '[MeteringPoint] Select Page index for Cold MeteringPoints',
  LoadMeteringPointReadingData = '[MeteringPoint] Load metering data',
  LoadMeteringPointReadingDataSuccess = '[MeteringPoint] Load metering data success',
  LoadMeteringPointReadingDataFail = '[MeteringPoint] Load metering data failed',
  ClearScrollPosition = '[MeteringPoint] Clear scroll postition for MeteringPoints table',
  LoadClimateCompensatedCO2Data = '[MeteringPoint] Load Climate Compensated CO2',
  LoadClimateCompensatedCO2DataSuccess = '[MeteringPoint] Load Climate Compensated CO2 success',
  LoadClimateCompensatedCO2DataFail = '[MeteringPoint] Load Climate Compensated CO2 fail',
  ClearClimateCompensatedCO2State = '[MeteringPoint] Clear Climate Compensated CO2 state',
  MeteringPointsFilterSaveData = '[MeteringPoint] Save filter settings',
}

export class LoadMeteringPoints implements Action {
  readonly type = MeteringPointActionTypes.LoadMeteringPointData;
  constructor() {}
}

export class LoadMeteringPointsSuccess implements Action {
  readonly type = MeteringPointActionTypes.LoadMeteringPointDataSuccess;
  constructor(public payload: MeteringPoint[]) {}
}

export class LoadMeteringPointsFail implements Action {
  readonly type = MeteringPointActionTypes.LoadMeteringPointDataFail;
  constructor(public payload: any) {}
}

export class LoadMeteringPointReadingData implements Action {
  readonly type = MeteringPointActionTypes.LoadMeteringPointReadingData;
  constructor(public payload: { masterMeteringPointId: number; meteringPointId: number; resolution: DatePeriodType }) {}
}

export class LoadMeteringPointReadingDataSuccess implements Action {
  readonly type = MeteringPointActionTypes.LoadMeteringPointReadingDataSuccess;
  constructor(
    public payload: { masterMeteringPointId: number; meteringPointId: number; data: MeteringPointReadingPoint[] }
  ) {}
}

export class LoadMeteringPointReadingDataFail implements Action {
  readonly type = MeteringPointActionTypes.LoadMeteringPointReadingDataFail;
  constructor(public payload: { masterMeteringPointId: number; meteringPointId: number }) {}
}

export class LoadMeteringPointsDisruptions implements Action {
  readonly type = MeteringPointActionTypes.LoadMeteringPointsDisruptionsData;
  constructor(public payload: { fromDate: Date }) {}
}

export class LoadMeteringPointsDisruptionsSuccess implements Action {
  readonly type = MeteringPointActionTypes.LoadMeteringPointsDisruptionsDataSuccess;
  constructor(public payload: MeteringPointDisruptions[]) {}
}

export class LoadMeteringPointsDisruptionsFail implements Action {
  readonly type = MeteringPointActionTypes.LoadMeteringPointsDisruptionsDataFail;
  constructor(public payload: any) {}
}

export class CreateReportKey implements Action {
  readonly type = MeteringPointActionTypes.CreateReportKey;
  constructor() {}
}
export class CreateReportKeySuccess implements Action {
  readonly type = MeteringPointActionTypes.CreateReportKeySuccess;
  constructor(public payload: string) {}
}
export class CreateReportKeyFail implements Action {
  readonly type = MeteringPointActionTypes.CreateReportKeyFail;
  constructor(public payload: any) {}
}

export class LoadMeteringPointFunctionControls implements Action {
  readonly type = MeteringPointActionTypes.LoadMeteringPointFunctionControls;
  constructor(public payload: { masterMeteringPointId: number; meteringPointId: number; }) {}
}
export class LoadMeteringPointFunctionControlsSuccess implements Action {
  readonly type = MeteringPointActionTypes.LoadMeteringPointFunctionControlsSuccess;
  constructor(
    public payload: { masterMeteringPointId: number; meteringPointId: number; data: MeteringPointFunctionControl[] }
  ) {}
}
export class LoadMeteringPointFunctionControlsFail implements Action {
  readonly type = MeteringPointActionTypes.LoadMeteringPointFunctionControlsFail;
  constructor(public payload: { masterMeteringPointId: number; meteringPointId: number }) {}
}


export class ClearMeteringPoints implements Action {
  readonly type = MeteringPointActionTypes.ClearMeteringPoints;
  constructor() {}
}
export class SelectMeteringPoint implements Action {
  readonly type = MeteringPointActionTypes.SelectMeteringPoint;
  constructor(public payload: MeteringPoint) {}
}
export class UnselectMeteringPoint implements Action {
  readonly type = MeteringPointActionTypes.UnselectMeteringPoint;
  constructor() {}
}
export class SelectMeteringPointById implements Action {
  readonly type = MeteringPointActionTypes.SelectMeteringPointById;
  constructor(public payload: number) {}
}

export class SelectTabIndexMeteringPoint implements Action {
  readonly type = MeteringPointActionTypes.SelectTabIndexMeteringPoint;
  constructor(public payload: MeteringPointTabType) {}
}
export class SelectTabIndexMeteringPoints implements Action {
  readonly type = MeteringPointActionTypes.SelectTabIndexMeteringPoints;
  constructor(public payload: number) {}
}

export class ClearScrollPosition implements Action {
  readonly type = MeteringPointActionTypes.ClearScrollPosition;
  constructor() {}
}

export class SelectPageIndexHotMeteringPoint implements Action {
  readonly type = MeteringPointActionTypes.SelectPageIndexHotMeteringPoint;
  constructor(
    public pageIndex: number,
    public pageSize: number,
    public sortColumn: string,
    public sortDirection: string,
    public scrollPosition: [number, number]
  ) {}
}
export class SelectPageIndexColdMeteringPoint implements Action {
  readonly type = MeteringPointActionTypes.SelectPageIndexColdMeteringPoint;
  constructor(
    public pageIndex: number,
    public pageSize: number,
    public sortColumn: string,
    public sortDirection: string,
    public scrollPosition: [number, number]
  ) {}
}
export class LoadClimateCompensatedCO2 implements Action {
  readonly type = MeteringPointActionTypes.LoadClimateCompensatedCO2Data;
  constructor(public payload: {
    meteringPointId: number;
    customerId: string,
    from: Date,
    to: Date,
    resolution: DatePeriodType,
    type: string,
    unit: string,
    meteringType: MeteringType,
    compensationKeyFigure: number
  }) {}
}

export class LoadClimateCompensatedCO2Success implements Action {
  readonly type = MeteringPointActionTypes.LoadClimateCompensatedCO2DataSuccess;
  constructor(public payload: ClimateCompensatedCO2Data ) {}
}
export class LoadClimateCompensatedCO2Fail implements Action {
  readonly type = MeteringPointActionTypes.LoadClimateCompensatedCO2DataFail;
  constructor(public payload: any) {}
}
export class ClearClimateCompensatedCO2State implements Action {
  readonly type = MeteringPointActionTypes.ClearClimateCompensatedCO2State;
  constructor() {}
}

// MeteringPoints filter
export class MeteringPointsFilterSave implements Action {
  readonly type = MeteringPointActionTypes.MeteringPointsFilterSaveData;
  constructor(public payload: MeteringPointSettings) {}
}

export type MeteringPointActions =
  | LoadMeteringPoints
  | LoadMeteringPointsSuccess
  | LoadMeteringPointsFail
  | LoadMeteringPointsDisruptions
  | LoadMeteringPointsDisruptionsSuccess
  | LoadMeteringPointsDisruptionsFail
  | CreateReportKey
  | CreateReportKeySuccess
  | CreateReportKeyFail
  | LoadMeteringPointFunctionControls
  | LoadMeteringPointFunctionControlsSuccess
  | LoadMeteringPointFunctionControlsFail
  | ClearMeteringPoints
  | SelectMeteringPoint
  | SelectMeteringPointById
  | UnselectMeteringPoint
  | SelectTabIndexMeteringPoint
  | SelectTabIndexMeteringPoints
  | SelectPageIndexHotMeteringPoint
  | SelectPageIndexColdMeteringPoint
  | LoadMeteringPointReadingData
  | LoadMeteringPointReadingDataSuccess
  | LoadMeteringPointReadingDataFail
  | ClearScrollPosition
  | LoadClimateCompensatedCO2
  | LoadClimateCompensatedCO2Success
  | LoadClimateCompensatedCO2Fail
  | ClearClimateCompensatedCO2State
  | MeteringPointsFilterSave;
